import StyledLink from '../StyledLink'
import { SPACE_API_ACCESS } from '../routes'
import type { Props } from '../types'

const LinkToSpaceApiAccess = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SPACE_API_ACCESS}
  >
    {children}
  </StyledLink>

export default LinkToSpaceApiAccess
